import styles from "../../Dashboard.module.css";
import { getStatusColor } from "../../../../../utils/outorga/dashboard";
import { grantStatus } from "../../../../../utils/Enums/grantStatus";
import permission from "../../../../../utils/permissions";
import auth from '../../../../../utils/auth'

const Grant = ({ marker, openCalendar }) => {

    const renderItem = (item, index) => {
        const percentage = item.percentage;

        return (
            <>
                <div key={index} className={styles.grantItem}>
                    <div className={styles.grantHeader}>
                        <span className={styles.grantTitle}>
                            {item.label}
                        </span>

                        <span
                            className={styles.grantBadge}
                            style={{ backgroundColor: getStatusColor(item.status) }}
                        >
                            {grantStatus[item.status]}
                        </span>
                    </div>

                    <div className={styles.progressRow}>
                        <div className={styles.progressWrapper}>
                            <div
                                className={styles.progressBar}
                                style={{
                                    width: `${percentage ?? 0}%`,
                                    backgroundColor: getStatusColor(item.status)
                                }}
                            />
                        </div>

                        <div className={styles.grantValue}>
                            {typeof item.value === "boolean"
                                ? "—"
                                : `${item.value ?? '—'}/${item.limit} ${item.unit}`}
                        </div>
                    </div>
                </div>

                <hr className={styles.grantHr} />
            </>
        );
    };

    const grants = marker?.outorga || [];
    const isMasterOrAdmin = auth.isMasterOrAdmin();
    const canAccess = isMasterOrAdmin || permission.canAccess("/calendario/");

    return (
        <>
            <div className={styles.grantContainer}>
                {grants.length ? (
                    grants.map(renderItem)
                ) : (
                    <div className={styles.grantContainerEmpty}>
                        Nenhum parâmetro disponível!
                    </div>
                )}
            </div>

            {(grants.length > 0 && canAccess) && (
                <div
                    className={styles.showCalendar}
                    onClick={openCalendar}
                >
                    <i className="fa fa-calendar" />
                    Ver calendário de violações
                </div>
            )}
        </>
    );
}

export default Grant;